import { useState, type ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { BarChart3, BookOpen, BookPlus, Building2, ChevronLeft, ChevronRight, CreditCard, FileCheck2, HandCoins, Landmark, PackageCheck, PiggyBank, LayoutDashboard, LogOut, Menu, ReceiptText, Settings, Wallet, WalletCards, X, UploadCloud, Banknote } from 'lucide-react';
import { useAuth } from '../lib/auth';

const nav = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/expenses', label: 'Expenses', icon: ReceiptText },
  { to: '/payments', label: 'Payments', icon: CreditCard },
  { to: '/fixed-assets', label: 'Fixed Assets', icon: PackageCheck },
  { to: '/staff-advances', label: 'Staff Advances', icon: WalletCards },
  { to: '/borrowings', label: 'Borrowings', icon: HandCoins },
  { to: '/operations-control', label: 'Lending & Savings Control', icon: PiggyBank },
  { to: '/microfinance-savings', label: 'Microfinance Accounting', icon: Landmark },
  { to: '/teller-treasury', label: 'Teller Cash & Treasury', icon: Banknote },
  { to: '/petty-cash', label: 'Petty Cash', icon: Wallet },
  { to: '/bank-reconciliation', label: 'Bank Reconciliation', icon: Landmark },
  { to: '/approvals', label: 'Approvals', icon: FileCheck2 },
  { to: '/reports', label: 'Reports', icon: BarChart3 },
  { to: '/general-ledger', label: 'General Ledger', icon: BookOpen },
  { to: '/manual-journals', label: 'Manual Journals', icon: BookPlus },
  { to: '/masters', label: 'Masters', icon: Building2 },
  { to: '/bulk-import', label: 'Bulk Import', icon: UploadCloud },
  { to: '/administration', label: 'Administration', icon: Settings },
];

export function AppShell({ children }: { children: ReactNode }) {
  const { profile, signOut } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <div className={`app-shell ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <aside className={`sidebar ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="brand">
          <div className="brand-mark">M</div>
          {!collapsed && <div><strong>MAGNA</strong><span>Accounting System</span></div>}
          <button className="mobile-close icon-button" onClick={() => setMobileOpen(false)}><X size={20} /></button>
        </div>
        <nav className="main-nav">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} onClick={() => setMobileOpen(false)} className={({ isActive }) => isActive ? 'active' : ''} title={collapsed ? label : undefined}>
              <Icon size={19} /><span>{label}</span>
            </NavLink>
          ))}
        </nav>
        <button className="collapse-button" onClick={() => setCollapsed((v) => !v)}>{collapsed ? <ChevronRight size={18} /> : <><ChevronLeft size={18} /> Collapse</>}</button>
      </aside>
      <div className="app-main">
        <header className="topbar">
          <button className="mobile-menu icon-button" onClick={() => setMobileOpen(true)}><Menu size={22} /></button>
          <div className="topbar-title"><strong>Branch Expense & Accounting</strong><span>{profile?.home_branch?.name || 'Consolidated access'}</span></div>
          <div className="user-area">
            <div className="user-avatar">{(profile?.full_name || 'U').slice(0, 1).toUpperCase()}</div>
            <div className="user-meta"><strong>{profile?.full_name || 'User'}</strong><span>{profile?.roles?.[0]?.name || 'User'}</span></div>
            <button className="icon-button" onClick={signOut} title="Sign out"><LogOut size={19} /></button>
          </div>
        </header>
        <main className="content">{children}</main>
      </div>
      {mobileOpen && <div className="mobile-overlay" onClick={() => setMobileOpen(false)} />}
    </div>
  );
}
